import DocumentAddButton from './DocumentAddButton';

export default DocumentAddButton;